<div class="home-page">
    <div class="home-page__float header-part">
        <div class="logo-title">
            <div class="logo">
                <img alt="" src="./assets/media/client-logos/quoc-huy.png">
            </div>
            <div class="title">
                <span>CỔNG ĐĂNG NHẬP TẬP TRUNG</span>
                <span>BỘ GIÁO DỤC ĐÀO TẠO</span>
            </div>
        </div>
    </div>
    <div class="home-page__wrapper">
        <div class="home-page__wrapper__login">
            <div class="wrap-logo-icon">
                <img alt="" src="../../../assets/media/background-Image/Logo_of_bogiaoduc.png">
                <span>Hệ thống quản lý tập trung IOC</span>
            </div>
            <div class="action-form float-form open-form">
                <form [formGroup]="formGroup">
                    <div class="form-group row">
                        <label class="col-3 col-form-label text-alert">Mật khẩu mới</label>
                        <div class="col-9">
                          <input type="password"
                            class="form-control form-control-lg form-control-solid"
                            placeholder="Nhập mật khẩu mới"
                            autocomplete="off"
                            formControlName="password"
                            [class.is-invalid]="isControlInvalid('password')"
                            [class.is-valid]="isControlValid('password')" 
                          />
                          <div
                            class="invalid-feedback"
                            *ngIf="controlHasError('required', 'password')"
                          >
                          Trường yêu cầu bắt buộc
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-3 col-form-label text-alert">Nhập lại</label>
                        <div class="col-9">
                          <input type="password"
                            class="form-control form-control-lg form-control-solid"
                            placeholder="Nhập lại mật khẩu mới"
                            autocomplete="off"
                            formControlName="cPassword"
                            [class.is-invalid]="isControlInvalid('cPassword')"
                            [class.is-valid]="isControlValid('cPassword')" 
                          />
                          <div
                            class="invalid-feedback"
                            *ngIf="controlHasError('required', 'cPassword')"
                          >
                          Trường yêu cầu bắt buộc
                          </div>
                          <div class="invalid-feedback" *ngIf="controlHasError('mismatch', 'cPassword')">Mật khẩu không trùng khớp.</div> 
                        </div>
                      </div>
                </form>
                <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary link-to-login">
                            <span (click)="changePasswordAction()">Đổi mật khẩu</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="home-page__float footer-part">
        <div class="logo-title">
            <div class="logo">
                <img alt="" src="./assets/media/client-logos/quoc-huy.png">
            </div>
            <div class="title">
                <span>CỔNG ĐĂNG NHẬP TẬP TRUNG</span>
                <span>BỘ GIÁO DỤC ĐÀO TẠO</span>
            </div>
        </div>
        <div class="address">
            <div class="address__wrapper">
                <span>Địa chỉ: <b>Số 35 Đại Cồ Việt, Hà Nội</b></span>
                <span>Điện thoại: <b>024.38695144; Fax: 024.38694085</b></span>
                <span>Email: <b>bogddt@moet.gov.vn</b></span>
            </div>
        </div>
    </div>
</div>